import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './TenantSwitchOverlay.css';

/**
 * TenantSwitchOverlay
 * Full-screen animated overlay shown when the user switches tenant.
 * Fades in immediately, then fades out after `displayDuration` ms.
 */
const TenantSwitchOverlay = ({tenantName, onDone, displayDuration = 900}) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), displayDuration);
    const doneTimer = setTimeout(() => onDone(), displayDuration + 300); // wait for fadeout animation

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [displayDuration, onDone]);

  return ReactDOM.createPortal(
    <div className={`tenant-switch-overlay${fadeOut ? ' fade-out' : ''}`}>
      {/* Top progress bar */}
      <div className="tenant-switch-progress-bar">
        <div className="tenant-switch-progress-bar-fill" />
      </div>

      {/* SVG hexagon spinner — regular hexagon, uniform sides */}
      <svg className="tenant-switch-hex-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="ts-hex-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366f1" />
            <stop offset="100%" stopColor="#8b5cf6" />
          </linearGradient>
        </defs>
        {/* Track */}
        <polygon
          className="ts-hex-track"
          points="50,8 89.8,31 89.8,69 50,92 10.2,69 10.2,31"
        />
        {/* Spinning arc */}
        <polygon
          className="ts-hex-arc"
          points="50,8 89.8,31 89.8,69 50,92 10.2,69 10.2,31"
        />
      </svg>

      {/* Tenant name */}
      <div className="tenant-switch-label">
        <span className="tenant-switch-label-heading">{'Switching to'}</span>
        {tenantName && (
          <span className="tenant-switch-label-name">{tenantName}</span>
        )}
      </div>

      {/* Dot pulse */}
      <div className="tenant-switch-dots">
        <span />
        <span />
        <span />
      </div>
    </div>,
    document.body
  );
};

TenantSwitchOverlay.propTypes = {
  tenantName: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  displayDuration: PropTypes.number,
};

export default TenantSwitchOverlay;


